// extracted by mini-css-extract-plugin
export default {"box":"frbzJ","title":"rA5Q2","notes":"aGcbF","checkbox":"GBnHr","cancelLink":"C8TQj","continueBtn":"hmBHS","actionsContainer":"zezm_"};